function Row(n,r,t){var e={raw:function(){return n},getLine:function(){return t}};return e}module.exports=Row;